<template>
  <div dir="rtl" ref="content">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>

    <v-card>
      <v-card-text>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  outline
                  disabled
                  v-model="select_client.code"
                  label="كود العميل "
                  v-validate="'required'"
                  :error-messages="errors.collect('form1.price')"
                  data-vv-name="name"
                  data-vv-scope="form1"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-autocomplete
                  outline
                  v-model="select_client"
                  :items="clients"
                  :hint="
                    `${
                      select_client.mandob_sales
                        ? select_client.mandob_sales.name
                        : ''
                    }- ${
                      select_client.mohafza ? select_client.mohafza.name : ''
                    }- ${select_client.city ? select_client.city.name : ''}- ${
                      select_client.region ? select_client.region.name : ''
                    }- ${select_client.branch ? select_client.branch.name : ''}`
                  "
                  item-text="name"
                  item-value="id"
                  label="أختر العميل "
                  persistent-hint
                  return-object
                  single-line
                  v-validate="'required'"
                  :error-messages="errors.collect('form1.manger')"
                  data-vv-name="manger"
                  data-vv-scope="form1"
                >
                  <template v-slot:append-outer>
                    <v-slide-x-reverse-transition mode="out-in">
                    </v-slide-x-reverse-transition>
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-text-field
                  outline
                  v-model="newItem.commercial_record"
                  label="السجل التجاري "
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-text-field
                  outline
                  v-model="newItem.tax_card"
                  label="البطاقة الضريبية"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="date"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="تاريخ الفاتورة"
                      readonly
                      outline
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false"
                      >Cancel</v-btn
                    >
                    <v-btn flat color="primary" @click="$refs.dialog.save(date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-flex>

              <v-flex xs12 sm6 md5>
                <v-autocomplete
                  v-model="select_item"
                  :items="items"
                  item-text="name"
                  item-value="id"
                  label="أختر الصنف"
                  persistent-hint
                  prepend-icon="mdi-city"
                  return-object
                >
                  <template v-slot:append-outer>
                    <v-slide-x-reverse-transition mode="out-in">
                    </v-slide-x-reverse-transition>
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md1>
                <v-text-field
                  outline
                  :disabled="!select_item.id || select_item.id == ''"
                  type="number"
                  v-model="item_num"
                  label="العدد"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md1>
                <v-text-field
                  outline
                  :disabled="!select_item.id || select_item.id == ''"
                  type="number"
                  v-model="price"
                  label="السعر"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-text-field
                  outline
                  disabled
                  v-model="gettotalpriceitem"
                  label="السعر الكلي"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-btn
                  color="orange"
                  :disabled="!select_item.id || select_item.id == ''"
                  @click="add_item"
                  >اضف الصنف</v-btn
                >
              </v-flex>
            </v-layout>
            <v-divider class=" my-1" inset horizontal></v-divider>
            <v-divider class=" my-1" inset horizontal></v-divider>

            <v-data-table
              :headers="headers"
              :items="added_items"
              class="elevation-1"
              :search="search"
              :loading="loading"
              :rows-per-page-items="rowsPerPageItems"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <v-btn style="width: 50px;" @click="remove_item(props.item)"
                    ><v-icon>delete</v-icon></v-btn
                  >
                </td>
                <td>{{ props.item.item_name }}</td>
                <td>{{ props.item.item_num }}</td>
                <td>{{ props.item.price }}</td>
                <td>{{ props.item.total_price }}</td>
              </template>
            </v-data-table>

            <v-layout>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  outline
                  disabled
                  v-model="fatwora_price"
                  label="السعر الاجمالي للفاتورة "
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-text-field
                  outline
                  disabled
                  v-model="the_tax_additional"
                  label="قيمة الضريبة المضافة"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md3>
                <v-text-field
                  outline
                  disabled
                  v-model="fatwora_price_after"
                  label="السعر الاجمالي بعد القيمة المضافة  "
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-text-field
                  outline
                  v-model="newItem.cheque_name"
                  label="في حالة الشيك  بإسم"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="orange darken-1" @click="save('form2')">
          حفظ الفاتورة الضريبية
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-layout> </v-layout>
    </v-card>

    <v-container>
      <p style="color:blue;font-size:20px;font-weight:bold;text-align:center">
        الفواتير الضريبية السابقة
      </p>
      <v-data-table
        :headers="headers2"
        :items="tax_fatworas"
        class="elevation-1"
        :loading="loading"
        :pagination.sync="pagination2"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status === '0'
                ? { 'background-color': '#D4B1B1' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td class="text-xs-right">{{ props.item.client_name }}</td>
            <td class="text-xs-right">{{ props.item.price }}</td>
            <td class="text-xs-right">{{ props.item.tax_additional }}</td>
            <td class="text-xs-right">{{ props.item.price_after }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="justify-center layout px-0">
              <v-icon small class="ml-4" @click="detailItem(props.item)">
                book
              </v-icon>
            </td>
            <td>
              <router-link :to="'/FinalFatworasPrint/' + props.item.id"
                ><v-icon>print</v-icon></router-link
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination2.page"
          :length="pages2"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>

    <v-dialog v-model="detail_dialog" width="800" dark style="padding:10px">
      <v-card>
        <v-card-title class="headline orange lighten-2" primary-title>
          تفاصيل الفاتورة
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4>
              اسم العميل :
              {{ item_detail.client_name }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              السعر :
              {{ item_detail.price }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              الضريبية الاضافية :
              {{ item_detail.tax_additional }}
            </v-flex>
            <v-flex xs12 sm6 md2>
              الأجمالي النهائي
              <br />
              {{ item_detail.price_after }}
            </v-flex>
            <v-flex xs12 sm6 md2>
              السجل التجاري
              <br />
              {{ item_detail.commercial_record }}
            </v-flex>
            <v-flex xs12 sm6 md2>
              البطاقة الضريبية
              <br />
              {{ item_detail.tax_card }}
            </v-flex>
            <v-flex xs12 sm6 md2>
              الشيك بأسم
              <br />
              {{ item_detail.cheque_name }}
            </v-flex>
            <v-flex xs12 sm6 md2>
              التاريخ
              <br />
              {{ item_detail.created_at }}
            </v-flex>
          </v-layout>
          <hr />
          <v-data-table
            :headers="headers3"
            :items="item_detail.items"
            class="elevation-1"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.item_name }}</td>
              <td>{{ props.item.item_num }}</td>
              <td>{{ props.item.price }}</td>
              <td>{{ props.item.total_price }}</td>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="detail_dialog = false">
            موافق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  tax_fatworas,
  add_tax_fatwora,
  clients,
  items
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    headers: [
      {
        text: "حذف ",
        align: "right",
        value: "code"
      },
      { text: "اسم الصنف ", value: "price_after", align: "right" },
      { text: "العدد", value: "client_name", align: "right" },
      { text: "السعر ", value: "taslim_date", align: "right" },
      { text: " السعر الكلي", value: "taslim_date", align: "right" }
    ],
    headers2: [
      { text: " اسم العميل", value: "client_name", align: "right" },
      { text: "السعر ", value: "price_after", align: "right" },
      { text: "الضريبة الاضافية ", value: "price_after", align: "right" },
      { text: "السعر النهائي ", value: "price_after", align: "right" },
      { text: "  التاريخ ", value: "taslim_date", align: "right" },
      { text: " تفاصيل", value: "store", sortable: false, align: "right" },
      { text: " فحص وطباعة", value: "store", sortable: false, align: "right" }
    ],
    headers3: [
      { text: " اسم الصنف", value: "client_name", align: "right" },
      { text: "العدد ", value: "price_after", align: "right" },
      { text: "السعر ", value: "price_after", align: "right" },
      { text: "السعر الكلي ", value: "price_after", align: "right" }
    ],
    search: "",
    loading: true,
    fatwora: [],
    items: [],
    clients: [],
    title: "",
    added_items: [],
    newItem: {
      price: "",
      tax_additional: "",
      price_after: "",
      client_name: "",
      commercial_record: "9407",
      tax_card: "230111637",
      client_id: "",
      cheque_name: ""
    },
    select_item: {},
    item_num: "",
    price: "",
    total_price: "",
    date: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    date3: new Date().toISOString().substr(0, 10),
    select_client: {},
    modal: false,
    detail_dialog: false,
    tax_fatworas: [],
    item_detail: {},
    pagination2: {
      rowsPerPage: 30,
      descending: true
    }
  }),
  computed: {
    pages2() {
      if (
        this.pagination2.rowsPerPage == null ||
        this.pagination2.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination2.totalItems / this.pagination2.rowsPerPage
      );
    },
    fatwora_price() {
      let tot_price = 0;
      for (let index = 0; index < this.added_items.length; index++) {
        tot_price += parseFloat(this.added_items[index].total_price);
      }
      return (this.newItem.price = tot_price);
    },
    the_tax_additional() {
      return (this.newItem.tax_additional =
        parseFloat(this.newItem.price) * 0.14);
    },
    fatwora_price_after() {
      return (this.newItem.price_after =
        parseFloat(this.newItem.price) +
        parseFloat(this.newItem.tax_additional));
    },
    gettotalpriceitem() {
      if (this.item_num != "" && this.price != "") {
        this.total_price = parseInt(this.item_num) * parseFloat(this.price);
        return this.total_price;
      } else {
        return (this.total_price = 0);
      }
    }
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    items().then(response => {
      this.items = response.data;
      this.loading = false;
    });

    clients().then(response => {
      this.clients = response.data;
      this.loading = false;
    });

    tax_fatworas().then(response => {
      this.tax_fatworas = response.data;
      this.pagination2.totalItems = response.data.length;
      this.loading = false;
    });
  },
  methods: {
    detailItem(order) {
      this.item_detail = order;
      this.detail_dialog = true;
    },
    add_item() {
      if (this.select_item.name) {
        this.added_items.push({
          item_name: this.select_item.name,
          item_num: this.item_num,
          price: this.price,
          total_price: this.total_price,
          item_id: this.select_item.id
        });
        this.select_item = { id: "" };
        this.item_num = "";
        this.price = "";
        this.total_price = "";
      }
    },
    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid && this.select_client.id != "") {
          this.loading = true;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.newItem.client_id = this.select_client.id;
          this.newItem.client_name = this.select_client.name;
          this.newItem.created_at = this.date;

          var frmData = new FormData();
          frmData.append("fatwora", JSON.stringify(this.newItem));
          frmData.append("items", JSON.stringify(this.added_items));

          add_tax_fatwora(frmData).then(response => {
            this.loading = false;
            this.$router.go(0);

            // this.$router.push("/FatworaDetailByID/" + this.fatwora_id);
          });
        }
      });
    }
  }
};
</script>
